var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reveive-feedcard"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}}),_c('div',{class:{
      'receive-btn': true,
      'disabled': _vm.loading || _vm.isReceive
    },on:{"click":_vm.receiveCard}},[_vm._v("立即领取\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }